
import store from './../../store';
import Vue from 'vue';

const success = (data, resolve) => {
  const appToastData = data;
  store.dispatch('fetchToastResp', appToastData);
  resolve();
};

const failed = (error, reject) => reject(error);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('user-app-version/toast-msg-resp')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/appToast/fetchUserAppToast.js